import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SetupCourse = () => {
  const [courseName, setCourseName] = useState('');
  const [courseDescription, setCourseDescription] = useState('');
  const [courseCategory, setCourseCategory] = useState(''); // Stores the selected category ID
  const [categories, setCategories] = useState([]); // Stores the list of categories
  const [message, setMessage] = useState('');

  // Fetch categories from the backend when the component loads
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://schoolofservice.co.za/backend/get-categories.php');
        if (response.data.status === 'success') {
          setCategories(response.data.categories); // Assuming 'categories' contains the list
        } else {
          setMessage('Failed to load categories.');
        }
      } catch (error) {
        setMessage('An error occurred while fetching categories.');
      }
    };

    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://schoolofservice.co.za/backend/save_course.php', {
        courseName,
        courseDescription,
        categoryID: courseCategory, // Save the category ID
      });

      if (response.data.status === 'success') {
        setMessage('Course saved successfully!');
        setCourseName('');
        setCourseDescription('');
        setCourseCategory('');
      } else {
        setMessage(response.data.message || 'Error saving course.');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div>
      <h3>Set Up Course</h3>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="courseName" className="form-label">Course Name</label>
          <input
            type="text"
            className="form-control"
            id="courseName"
            value={courseName}
            onChange={(e) => setCourseName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="courseDescription" className="form-label">Course Description</label>
          <textarea
            className="form-control"
            id="courseDescription"
            rows="3"
            value={courseDescription}
            onChange={(e) => setCourseDescription(e.target.value)}
            required
          ></textarea>
        </div>
        <div className="mb-3">
          <label htmlFor="courseCategory" className="form-label">Course Category</label>
          <select
            className="form-select"
            id="courseCategory"
            value={courseCategory}
            onChange={(e) => setCourseCategory(e.target.value)} // Stores the category ID
            required
          >
            <option value="">Select Category</option>
            {categories.map((category) => (
              <option key={category.categoryID} value={category.categoryID}>
                {category.categoryName}
              </option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn btn-primary">Save Course</button>
      </form>
    </div>
  );
};

export default SetupCourse;
